import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

interface ModalState {
  nonMemberModalState: boolean
}

const initialState: ModalState = {
  nonMemberModalState: false,
}

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    changeNonMemberModalState: (state, action: PayloadAction<boolean>) => {
      state.nonMemberModalState = action.payload
    },
  },
})

export const { changeNonMemberModalState } = modalSlice.actions
export default modalSlice.reducer
